import React from 'react';
import { Typography, theme } from 'antd';

const { Text } = Typography;

interface AppointmentDetailSectionLabelProps {
  icon?: React.ReactNode;
  children: React.ReactNode;
}

/** Small uppercase section heading used inside appointment details. */
export function AppointmentDetailSectionLabel({ icon, children }: AppointmentDetailSectionLabelProps) {
  const { token } = theme.useToken();

  return (
    <Text
      type="secondary"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        marginBottom: token.marginXS,
        fontSize: token.fontSizeSM,
        fontWeight: 600,
        letterSpacing: 0.5,
        textTransform: 'uppercase'
      }}>
      {icon}
      {children}
    </Text>
  );
}
